import React, {Component} from 'react';
import {Route, withRouter, Switch, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import AppLayout from '../../layout/AppLayout';
import {setGrants} from '../../redux/menu/actions';
import {
  addStatistics,
  addGroupMessageSettings,
  addFinancialGroups,
  addKycItems,
  addGiftCardSettings,
  addNetworks,
} from '../../redux/app/actions';
import {addGeneralInfo} from '../../redux/general/actions';
import users from './users';
import kyc from './kyc';
import cardNumbers from './cardNumbers';
import ibanNumbers from './ibanNumbers';
import bankAccounts from './bankAccounts';
import deposits from './deposits';
import withdraws from './withdraws';
import settings from './settings';
import notices from './notices';
// import tradingBots from './tradingBots';
import bonusCards from './bonusCards';
import giftCards from './giftCards';
import campaigns from './campaigns';
import tickets from './tickets';
import reports from './reports';
import analytics from './analytics';
import management from './management';
import alerts from './alerts';
import Api from '../../services/Api';
import {application, fetchIntervalTime} from '../../constants/configs';
import moment from 'moment-timezone';
import Rbac from '../../components/Rbac';
import {keyBy} from 'lodash';
import zarinpalTransfers from './zarinpalTransfers';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    moment.tz.setDefault('Asia/Tehran');
  }

  async componentDidMount() {
    await this.fetchData();
    this.interval = setInterval(this.fetchStatistics, fetchIntervalTime * 4);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchData = async () => {
    await Promise.all([
      this.fetchGrants(),
      this.fetchGeneralInfo(),
      this.fetchStatistics(),
      this.fetchGroupMessageSettings('SMS'),
      // this.fetchGroupMessageSettings('EMAIL'),
      this.fetchKycItems(),
      this.fetchNetworks(),
    ]);
    if (application.supportV2 && Rbac.hasPermission('view_gift')) {
      await this.fetchGiftCardsSettings();
    }
    // if (Rbac.hasPermission('view_financial-groups')) {
    //   await this.fetchFinancialGroups();
    // }
    this.setState({
      loading: false,
    });
  };

  fetchGroupMessageSettings = async type => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/group-message-settings', null, {
        params: {
          type,
        },
      });
      this.props.addGroupMessageSettings({
        type,
        ...data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchKycItems = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/kyc-items');
      this.props.addKycItems(data);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchNetworks = async () => {
    try {
      const {data} = await Api.invoke('GET', '/networks');
      this.props.addNetworks(keyBy(data, 'mainToken'));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchGrants = async () => {
    try {
      const username = await localStorage.getItem('username');
      if (username) {
        if (username === 'superadmin') {
          this.props.setGrants(['*']);
        } else {
          const {data} = await Api.invoke('GET', '/admin-ui/grants');
          this.props.setGrants(data);
        }
      } else {
        await Api.logOut();
      }
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchGeneralInfo = async () => {
    try {
      let data = {};
      await Promise.all([
        Api.invoke('GET', '/v2/tokens').then(res => {data.tokens = res.data;}),
        Api.invoke('GET', '/v2/pairs').then(res => {data.pairs = res.data;}),
      ]);
      this.props.addGeneralInfo(data);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchFinancialGroups = async () => {
    try {
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/financial-groups',
        null,
        {
          api: {
            displayError: false,
          },
        }
      );
      this.props.addFinancialGroups(data);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchStatistics = async () => {
    try {
      const {data} = await Api.invoke(
        'GET',
        application.supportV2 ? '/v2/admin-ui/statistics' : '/admin-ui/statistics',
        null,
        {
          api: {
            displayError: false,
          },
        }
      );
      this.props.addStatistics(data);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchGiftCardsSettings = async () => {
    try {
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/giftCards/settings',
        null,
        {
          api: {
            displayError: false,
          },
        }
      );
      this.props.addGiftCardSettings(data);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  render() {
    const {match, permissions} = this.props;

    if(!permissions || this.state.loading) {
      return <div className="loading" />;
    }

    return (
      <AppLayout>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/users`}/>
          {/*<Redirect exact from={`${match.url}/analytics`} to={`${match.url}/analytics/all`}/>*/}
          {/*<Route path={`${match.url}/analytics/:group`} component={analytics}/>*/}
          <Route path={`${match.url}/analytics`} component={analytics}/>
          <Route path={`${match.url}/users`} component={users}/>
          <Route path={`${match.url}/kyc`} component={kyc}/>
          <Route path={`${match.url}/cardNumbers`} component={cardNumbers}/>
          <Route path={`${match.url}/ibanNumbers`} component={ibanNumbers}/>
          <Route path={`${match.url}/bankAccounts`} component={bankAccounts}/>
          <Route path={`${match.url}/deposits`} component={deposits}/>
          <Route path={`${match.url}/withdraws`} component={withdraws}/>
          <Route path={`${match.url}/settings`} component={settings}/>
          <Route path={`${match.url}/notifications`} component={notices}/>
          <Route path={`${match.url}/alerts`} component={alerts}/>
          <Route path={`${match.url}/giftCards`} component={giftCards}/>
          <Route path={`${match.url}/bonusCards`} component={bonusCards}/>
          {/*<Route path={`${match.url}/tradingBots`} component={tradingBots}/>*/}
          <Route path={`${match.url}/campaigns`} component={campaigns}/>
          <Route path={`${match.url}/tickets`} component={tickets}/>
          <Route path={`${match.url}/reports`} component={reports}/>
          <Route path={`${match.url}/management`} component={management}/>
          <Route path={`${match.url}/zarinpal-transfers`} component={zarinpalTransfers}/>
          <Redirect to="/error"/>
        </Switch>
      </AppLayout>
    );
  }
}

const mapStateToProps = ({menu}) => {
  const {containerClassnames, permissions} = menu;
  return {containerClassnames, permissions};
};

const mapActionsToProps = {
  setGrants,
  addGeneralInfo,
  addStatistics,
  addFinancialGroups,
  addGroupMessageSettings,
  addGiftCardSettings,
  addKycItems,
  addNetworks,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionsToProps,
  )(App));
